import { HelperCore, HelpOther } from '@/common/helper';
import { makeAutoObservable, runInAction } from 'mobx';
import { createSlsLogger } from '@public/log/sls';
import Request from '@src/common/request';
import wcpDownloadModal from './';
const slsLogger = createSlsLogger('client');

class Store {
  loading = false
  constructor() {
    makeAutoObservable(this);
  }

  agentBatchDownload(data, cb) {
    if ( !data?.files?.length) {
      HelpOther.toast('请选择需要下载文件！', 'error')
      return
    }
    runInAction(() => {
      this.loading = true
    })
    Request.post(
      '/ai_agent/chat/download',
      {
        ...data,
      },
      { dataIsJson: true }
    )
      .then(res => {
        if (res.code == 0) {
          cb(res?.data?.download_url)
          runInAction(() => {
            wcpDownloadModal.close();
            this.loading = false
          });
        }
        
      })
      .catch(e => {
        runInAction(() => {
          // wcpDownloadModal.close();
          HelpOther.toast('下载失败,请稍后重试！', 'error')
          this.loading = false
        });
      });
  }
}

const wcpDownloadStore = new Store();
export default wcpDownloadStore;
